import { SegmentId } from './Segment';

export const DEFAULT_SEGMENT_ID: SegmentId = 'Everyone';
